import { render, staticRenderFns } from "./noWatchTips.vue?vue&type=template&id=07bb65fc&scoped=true"
import script from "./noWatchTips.vue?vue&type=script&lang=js"
export * from "./noWatchTips.vue?vue&type=script&lang=js"
import style0 from "./noWatchTips.vue?vue&type=style&index=0&id=07bb65fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb65fc",
  null
  
)

export default component.exports